<template>
    <div class="">
        <nav class="navbar navbar-expand-lg bg-body-tertiary fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="https://i.postimg.cc/2jFYZQ4G/ingongoma.jpg" alt="Bootstrap" width="40" height="34">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 text-center">
        <li class="nav-item ">
        <RouterLink to="/">HEADLINES</RouterLink>
        </li>
        <li class="nav-item ">
         <RouterLink to="/about">ARTICLES</RouterLink>
        </li>
        
      </ul>
      
    </div>
  </div>
</nav>
    </div>
</template>
<script>
export default {
    
}
</script>
<style>
    
</style>